import React from 'react';

const RequestStatusBadge = ({ status }) => {
  let color;
  
  switch (status) {
    case 'pending':
      color = 'bg-yellow-100 text-yellow-800';
      break;
    case 'approved':
      color = 'bg-green-100 text-green-800';
      break;
    case 'fulfilled':
      color = 'bg-blue-100 text-blue-800';
      break;
    case 'rejected':
      color = 'bg-red-100 text-red-800';
      break;
    case 'canceled':
      color = 'bg-gray-100 text-gray-800';
      break;
    default:
      color = 'bg-gray-100 text-gray-800';
  }
  
  return (
    <span className={`inline-flex rounded-full px-2 text-xs font-semibold leading-5 ${color}`}>
      {status}
    </span>
  );
};

export default RequestStatusBadge;
